import { Theme, css } from '@emotion/react'
import styled from '@emotion/styled'
import { graphql, useStaticQuery } from 'gatsby'
import { FC } from 'react'

import Container from '../../../components/Container'
import { ButtonStyled } from '../../../components/common/Button/styles'
import { useIntlLabel } from '../../../intl'
import { HomeRequestSectionQuery } from './__generated__/HomeRequestSectionQuery'

const ContainerStyled = styled.section((props) => ({
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: props.theme.color.neutral.salt[100],
    boxSizing: 'border-box',
    color: props.theme.sections.serviceRequest.foregroundDark,
}))

const ContainerContent = styled.div((props) => ({
    display: 'flex',
    justifyContent: 'space-between',
    [props.theme.breakpoints.down(props.theme.breakpoints.md)]: {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
}))

const ContainerTextStyled = styled.div((props) => ({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '60%',
    padding: `${props.theme.spacing(10)} 0`,
    [props.theme.breakpoints.down(props.theme.breakpoints.md)]: {
        paddingBottom: 0,
        maxWidth: '100%',
        padding: `${props.theme.spacing(5)} 0`,
    },
}))

const TitleStyled = styled.h3((props) => ({
    fontSize: 24,
    fontWeight: 700,
    color: props.theme.color.brand.secondary[900],
}))

const ParagraphStyled = styled.p((props) => ({
    fontSize: 16,
    color: props.theme.color.brand.secondary[900],
}))

const linkStyle = (theme: Theme) =>
    css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 4,
        backgroundColor: theme.sections.serviceRequest.backgroundButton,
        color: theme.sections.serviceRequest.foregroundLight,
        width: 208,
        height: 52,
        textDecoration: 'none',
    })

const GirlImageStyled = styled.img((props) => ({
    marginBottom: 0,
    display: 'block',
    height: '400px',
    [props.theme.breakpoints.down(props.theme.breakpoints.md)]: {},
}))

const HomeRequestSection: FC = () => {
    const getIntlLabel = useIntlLabel()

    const { strapiRequestSection } = useStaticQuery<HomeRequestSectionQuery>(graphql`
        query HomeRequestSectionQuery {
            strapiRequestSection {
                contactSlug
                contactSlug_mg
                description
                description_mg
                question
                question_mg
                contactLabel
                contactLabel_mg
                requestImage {
                    localFile {
                        publicURL
                    }
                }
            }
        }
    `)

    return (
        <ContainerStyled>
            <Container>
                <ContainerContent>
                    <ContainerTextStyled>
                        <TitleStyled>{getIntlLabel(strapiRequestSection, 'question')}</TitleStyled>
                        <ParagraphStyled>
                            {getIntlLabel(strapiRequestSection, 'description')}
                        </ParagraphStyled>
                        <ButtonStyled
                            color={'secondary'}
                            href={
                                /*`/${getIntlLabel(strapiRequestSection, 'contactSlug')}`*/ 'mailto:torolalana@digital.gov.mg'
                            }
                        >
                            {getIntlLabel(strapiRequestSection, 'contactLabel')}
                        </ButtonStyled>
                    </ContainerTextStyled>
                    <GirlImageStyled
                        src={strapiRequestSection?.requestImage?.localFile?.publicURL ?? ''}
                        alt="Request photo"
                    />
                </ContainerContent>
            </Container>
        </ContainerStyled>
    )
}

export default HomeRequestSection
